module.exports = __webpack_public_path__ + "assets/img/elem3-transperent-bcg.ad1f7e6e.png";